import { render, staticRenderFns } from "./sampleLog.vue?vue&type=template&id=1560dc92&scoped=true"
import script from "./sampleLog.vue?vue&type=script&lang=js"
export * from "./sampleLog.vue?vue&type=script&lang=js"
import style0 from "./sampleLog.vue?vue&type=style&index=0&id=1560dc92&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1560dc92",
  null
  
)

export default component.exports